import React from 'react';

import { darken, withStyles } from '@material-ui/core/styles';
import { Switch as MuiSwitch } from '@material-ui/core';
import { SwitchProps } from '@material-ui/core/Switch';

import { ChatbotIcon } from 'src/components/ChatbotIcon';

const ChatBotSwitch = withStyles((theme) => ({
    root: {
        width: 90,
        height: 40,
        padding: 0,
        margin: theme.spacing(1),
    },

    switchBase: {
        marginTop: 2,
        padding: 2,
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
        borderRight: `1px solid ${theme.palette.divider}`,
        boxShadow: `0 0 3px ${theme.palette.divider}`,
        '&$checked': {
            transform: 'translateX(52px)',
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.background.paper,
            boxShadow: `0 0 3px ${theme.palette.background.default}`,
            '&:hover': {
                backgroundColor: darken(theme.palette.background.paper, 0.02),
                boxShadow: `0 0 3px ${theme.palette.background.default}`,
            },

            '& + $track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: theme.palette.primary.main,
            border: `6px solid ${theme.palette.background.paper}`,
        },
    },

    thumb: {
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.background.paper,
        backgroundColor: theme.palette.background.paper,
    },

    track: {
        borderRadius: 40 / 2,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.action.hover,
        opacity: 1,
    },

    checked: {},
    focusVisible: {},
}))((props: SwitchProps) => {
    const { classes, ...rest } = props;

    const ICON_PROPS = {
        width: 32,
        height: 32,
        padding: 5,
    };

    return (
        <MuiSwitch
            {...rest}
            classes={classes}
            icon={<ChatbotIcon style={ICON_PROPS} mode={'off'} />}
            checkedIcon={<ChatbotIcon style={ICON_PROPS} />}
        />
    );
});

export const Switch = ({
    checked,
    onChange = () => {},
    name = '',
    ...rest
}) => {
    return (
        <ChatBotSwitch
            checked={checked}
            onChange={onChange}
            name={name}
            {...rest}
        />
    );
};
